<template>
  <el-container id="aDev">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main1">
      <el-header style="height:100px;line-height:30px;padding:0;background:#FFFFFF">
        <div style="display:flex;white-space: nowrap;">
          <div style="width:25%">
            <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">全部设备</p>
            <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_all }}个</p>
          </div>
          <el-divider direction="vertical" class="fg_x"></el-divider>
          <div style="width:25%">
            <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">在线设备</p>
            <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_zx }}个</p>
          </div>
          <el-divider direction="vertical" class="fg_x"></el-divider>
          <div style="width:25%">
            <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">离线设备</p>
            <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_lx }}个</p>
          </div>
          <el-divider direction="vertical" class="fg_x"></el-divider>
          <div style="width:25%">
            <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">故障设备</p>
            <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_err }}个</p>
          </div>
        </div>
      </el-header>
      <el-divider class="fg_x"></el-divider> <!--分割线-->
      <el-main style="background:#FFFFFF;padding:10px;margin-top:0px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <span style="margin-left:0;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_pid" ref='select1' @change="init_getDev()"
                       clearable filterable placeholder="全部类型" @click.native="getPid()"
                       style="width:10vw;">
              <el-option
                v-for="item in li_pid"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                  <!--@click.native="show_table(httpData,roomData)"-->
              </el-option>
            </el-select>
          </span>
          <span style="margin-left:0.5vw;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_state" ref='select2' @change="init_getDev()"
                       clearable filterable placeholder="全部状态"
                       style="width:10vw;">
              <el-option
                v-for="item in li_state"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </span>
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
              placeholder="输入设备名称查询"
              style="width:10vw;"
              prefix-icon="el-icon-search"
              clearable
              @change="init_getDev()"
              v-model="scan_name">
            </el-input>
          </span>
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
              placeholder="输入设备Did查询"
              style="width:10vw;"
              prefix-icon="el-icon-search"
              clearable
              @change="init_getDev()"
              v-model="scan_mac">
            </el-input>
          </span>
          <el-button @click="addDev" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:auto;margin-right:16px">
            新增设备
          </el-button>
        </div>
        <el-table :data=tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead" :key=item>
            <el-table-column v-if="d.key!=='设备状态'"
                             :prop=d.val :label=d.key :width="d.w">
            </el-table-column>
            <el-table-column v-else :label=d.key width="200">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row['times']" placement="bottom">
                  <p @click="query_device(scope.row)"
                     style="font-size: 16px">{{ scope.row["statusName"] }}
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
          </div>
          <el-table-column
            label="状态"
            width="200">
            <template slot-scope="scope">
              <el-button @click="find_dvcState(scope.row)" type="text" size="small"
                         style="color:#1D66DD;font-size: 16px">触发
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="控制"
            width="200">
            <template slot-scope="scope">
              <el-button v-if="scope.row.pid==='ble_gateway'" @click="syn_dvc(scope.row)" type="text" size="small"
                         style="color:#1D66DD;font-size: 16px">同步
              </el-button>
              <el-button v-else @click="ctrol_dvc(scope.row)" type="text" size="small"
                         style="color:#1D66DD;font-size: 16px">控制
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="change_dvc(scope.row)" type="text" size="small" icon="el-icon-edit"
                         style="color:#72767b;font-size: 16px"/>
              <el-button @click="del_Dev(scope.row)" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float:right; margin-right:0.5vw;margin-top:5px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page="page"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
      title="删除提示"
      :visible.sync="daidelDev"
      width="30%">
      <span>确定删除该设备吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daidelDev = false">取 消</el-button>
        <el-button type="primary" @click=delDev()>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="360px" class="dialog_daiAddDev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiCtrol'> <!--v-draggable 拖动-->
      <div v-for="d in fil_li_ctl"
           style="display:flex;margin-bottom:10px;height:50px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <span style="margin-left:0px; width:100px; color: #000000; font-size: 13px">
            {{ d.desc }}：
        </span>
        <el-select v-if="d.type==='enum'&&d.mode==='r'" v-model="d.value" ref='select3'
                   clearable filterable placeholder="设备状态" disabled
                   style="width:200px;">
          <el-option
            v-for="item in d.li_d"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="d.type==='enum'" v-model="d.value" ref='select4'
                   clearable filterable placeholder="设备状态"
                   style="width:200px;">
          <el-option
            v-for="item in d.li_d"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input-number v-else-if="d.type==='int'&&d.mode==='r'" size="medium" v-model="d.value"
                         style="width:200px;"
                         :step=parseInt(d.step) :min=parseInt(d.min) :max=parseInt(d.max) :disabled="true">
        </el-input-number>
        <el-input-number v-else-if="d.type==='int'&&d.mode!=='r'" size="medium" v-model="d.value"
                         style="width:200px;"
                         :step=parseInt(d.step) :min=parseInt(d.min) :max=parseInt(d.max)>
        </el-input-number>
        <el-input-number v-else-if="d.type==='float'&&d.mode==='r'" size="medium" v-model="d.value"
                         style="width:200px;"
                         :precision="2" :step=parseFloat(d.step) :min=parseFloat(d.min) :max=parseFloat(d.max)
                         :disabled="true">
        </el-input-number>
        <el-input-number v-else-if="d.type==='float'&&d.mode!=='r'" size="medium" v-model="d.value"
                         style="width:200px;"
                         :precision="2" :step=parseFloat(d.step) :min=parseFloat(d.min) :max=parseFloat(d.max)>
        </el-input-number>
        <el-input v-else-if="d.mode!=='r'" style="margin-left:5px; width: 200px;; color: #000000; font-size: 13px"
                  v-model="d.value">
        </el-input>
        <span v-else style="margin-left:5px; width: 200px;; color: #000000; font-size: 13px">
          {{ d.value }}
        </span>
        <el-button v-if="d.mode!=='r'" @click="on_pwr(d.name,d.value)" type="primary" style="margin-left:5px">发送
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="360px" class="dialog_daiAddDev1"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiCtrolKt'> <!--v-draggable 拖动-->
      <div v-if="daiCtrolKt&&li_ctl.length>6"
           style="display:flex;background:#5AA3FF;border-radius:5px;height:90px;padding-top: 10px;color: #FFFFFF">
        <div style="width: 50%;text-align: center">
          <p style="font-size:18px">{{ li_ctl[4]["value"] }} ℃</p>
          <p style="font-size:16px">设定温度</p>
        </div>
        <div style="width: 50%;text-align: center">
          <p style="font-size:18px">{{ getLabelByValue(li_ctl[3]["li_d"],li_ctl[3]["value"]) }}</p>
          <p style="font-size:16px">当前模式</p>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:10px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">开关</p>
        </div>
        <el-radio-group v-model="li_ctl[2]['value']" size="medium"
                        @change="on_pwr(li_ctl[2]['name'],li_ctl[2]['value'])"
                        style="display:flex;text-align: right;margin-left:auto;margin-right:16px;padding-top:7px">
          <div v-for="d in li_ctl[2]['li_d']">
            <el-radio-button :label="d.value">
              {{ d.label }}
            </el-radio-button>
          </div>
        </el-radio-group>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width:20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">温度</p>
        </div>
        <el-slider v-model="li_ctl[4]['value']" :min="li_ctl[4]['min']" :max="li_ctl[4]['max']"
                   @change="on_pwr(li_ctl[4]['name'],li_ctl[4]['value'])"
                   style="width: 100%;margin-right:16px;margin-left:16px;margin-top:5px"></el-slider>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">模式</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[3]['value']" ref='select5'
                     filterable placeholder="模式" @change="on_pwr(li_ctl[3]['name'],li_ctl[3]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[3]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">风速</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[5]['value']" ref='select6'
                     filterable placeholder="风速" @change="on_pwr(li_ctl[5]['name'],li_ctl[5]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[5]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>10"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">同步状态</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-button size="medium" style="height:40px;" @click="on_pwr(li_ctl[1]['name'],li_ctl[1]['value'])">同步
          </el-button>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>10"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">搜索内机</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-button size="medium" style="height:40px;" @click="on_pwr(li_ctl[0]['name'],li_ctl[0]['value'])">搜索
          </el-button>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>10"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-button
            v-if="daiCtrolKt&&(li_ctl[6]['value']!==0||li_ctl[7]['value']!==0||li_ctl[8]['value']!==0||li_ctl[9]['value']!==0)"
            type="primary" size="medium" style="height:40px;" @click="change_lock">
            已锁
          </el-button>
          <el-button v-else size="medium" style="height:40px;" @click="change_lock">未锁</el-button>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>9&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定开关</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[7]['value']" ref='select7'
                     filterable placeholder="锁定开关" @change="on_pwr(li_ctl[7]['name'],li_ctl[7]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[7]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>9&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定模式</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[8]['value']" ref='select8'
                     filterable placeholder="锁定模式" @change="on_pwr(li_ctl[8]['name'],li_ctl[8]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[8]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="li_ctl.length>9&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定温度</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[9]['value']" ref='select9'
                     filterable placeholder="锁定温度" @change="on_pwr(li_ctl[9]['name'],li_ctl[9]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[9]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>9&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定风速</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[10]['value']" ref='select10'
                     filterable placeholder="锁定风速" @change="on_pwr(li_ctl[10]['name'],li_ctl[10]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[10]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKt&&li_ctl.length>9&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 30%;text-align: left;margin-left:16px">
          <p style="font-size:16px">全部解锁</p>
        </div>
        <div style="display:flex;text-align:right;width:90px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-button size="medium" style="height:40px;" type="primary"
                     @click="on_pwr(li_ctl[11]['name'],li_ctl[11]['value'])">
            全部解锁
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="350px" class="dialog_daiAddDev1"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiCtrolKtSon'> <!--v-draggable 拖动-->
      <div v-if="daiCtrolKtSon&&li_ctl.length>6"
           style="display:flex;background:#5AA3FF;border-radius:5px;height:90px;padding-top: 10px;color: #FFFFFF">
        <div style="width: 50%;text-align: center">
          <p style="font-size:18px">{{ li_ctl[2]["value"] }} ℃</p>
          <p style="font-size:16px">设定温度</p>
        </div>
        <div style="width: 50%;text-align: center">
          <p style="font-size:18px">{{ getLabelByValue(li_ctl[1]["li_d"],li_ctl[1]["value"]) }}</p>
          <p style="font-size:16px">当前模式</p>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:10px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">开关</p>
        </div>
        <el-radio-group v-model="li_ctl[0]['value']" size="medium"
                        @change="on_pwr(li_ctl[0]['name'],li_ctl[0]['value'])"
                        style="display:flex;text-align: right;margin-left:auto;margin-right:16px;padding-top:7px">
          <div v-for="d in li_ctl[0]['li_d']">
            <el-radio-button :label="d.value">
              {{ d.label }}
            </el-radio-button>
          </div>
        </el-radio-group>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width:20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">温度</p>
        </div>
        <el-slider v-model="li_ctl[2]['value']" :min="li_ctl[2]['min']" :max="li_ctl[2]['max']"
                   @change="on_pwr(li_ctl[2]['name'],li_ctl[2]['value'])"
                   style="width: 100%;margin-right:16px;margin-left:16px;margin-top:5px"></el-slider>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">模式</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <!--@visible-change='show_change1'-->
          <el-select v-model="li_ctl[1]['value']" ref='select11'
                     filterable placeholder="模式" @change="on_pwr(li_ctl[1]['name'],li_ctl[1]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[1]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">风速</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[3]['value']" ref='select12'
                     filterable placeholder="风速" @change="on_pwr(li_ctl[3]['name'],li_ctl[3]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[3]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 20%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-button
            v-if="daiCtrolKtSon&&(li_ctl[4]['value']!==0||li_ctl[5]['value']!==0||li_ctl[6]['value']!==0||li_ctl[7]['value']!==0)"
            type="primary" size="medium" style="height:40px;" @click="change_lock">
            已锁
          </el-button>
          <el-button v-else size="medium" style="height:40px;" @click="change_lock">未锁</el-button>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定开关</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[4]['value']" ref='select13'
                     filterable placeholder="锁定开关" @change="on_pwr(li_ctl[4]['name'],li_ctl[4]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[4]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定模式</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[5]['value']" ref='select14'
                     filterable placeholder="锁定模式" @change="on_pwr(li_ctl[5]['name'],li_ctl[5]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[5]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定温度</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[6]['value']" ref='select15'
                     filterable placeholder="锁定温度" @change="on_pwr(li_ctl[6]['name'],li_ctl[6]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[6]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 40%;text-align: left;margin-left:16px">
          <p style="font-size:16px">锁定风速</p>
        </div>
        <div style="display:flex;text-align:right;width:80px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-select v-model="li_ctl[7]['value']" ref='select16'
                     filterable placeholder="锁定风速" @change="on_pwr(li_ctl[7]['name'],li_ctl[7]['value'])"
                     style="width:100%;">
            <el-option
              v-for="item in li_ctl[7]['li_d']"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="daiCtrolKtSon&&li_ctl.length>6&&is_lock"
           style="display:flex;height:50px;margin-top:6px;background:#FFFFFF;border-radius:5px;color:#353535">
        <div style="width: 30%;text-align: left;margin-left:16px">
          <p style="font-size:16px">全部解锁</p>
        </div>
        <div style="display:flex;text-align:right;width:90px;margin-left:auto;margin-right:16px;margin-top:5px">
          <el-button size="medium" style="height:40px;" type="primary"
                     @click="on_pwr(li_ctl[8]['name'],li_ctl[8]['value'])">
            全部解锁
          </el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import moment from "moment";

export default {
  name:"aDev",
  data(){
    return {
      is_lock:false,
      is_one:true,
      xz_kg:"开机",
      xz_mode:"制热",
      xz_fan:"低风",
      xz_temp:"常温",
      lockTemp:false,
      xz_temp_min:"17",
      xz_temp_max:"31",
      websocket:null,
      reconnectInterval:5000, // 5秒尝试重连一次
      heartbeatMsg:'ping',
      heartbeatInterval:60000, // 60秒发送一次心跳
      titles:"",
      h_text:"设备列表",
      li_h_text:[
        {"text":"设备管理","colour":"#B7B7B7","pages":""}
      ],
      daiCtrol:false,
      daiCtrolKt:false,
      daiCtrolKtSon:false,
      edi_pwr:1,
      pid:0,
      li_ctl:[],
      li_data:[],
      // li_ctl: [{
      //   "name": "pwr",
      //   "desc": "开关",
      //   "type": "enum",
      //   "value": "0",
      //   "li_d": [{"label": "开", "value": "0"}],
      // }, {
      //   "name": "bright",
      //   "desc": "亮度",
      //   "type": "int",
      //   "step": "1",
      //   "min": "1",
      //   "max": "100",
      //   "label": '关闭',
      //   "value": "1"
      // }],
      state_all:0,
      state_zx:0,
      state_lx:0,
      state_err:0,
      edi_pid:"",
      li_pid:[], /*角色列表*/
      li_dev:[],
      li_deviceList:[],
      scan_mac:"",
      scan_name:"",
      page:1,
      total:0,
      pageSize:10,
      pidPage:1,
      pidPageSize:10,
      pidTotal:10,
      maxHeight:window.innerHeight - 350,
      defHead:[
        {'key':"序号",'val':"item","w":"200px"},
        {'key':"设备类型",'val':"authName","w":"auto"},
        {'key':"设备名称",'val':"devName","w":"auto"},
        {'key':"设备Did",'val':"devMac","w":"auto"},
        {'key':"所属区域",'val':"devArea","w":"auto"},
        {'key':"设备状态",'val':"statusName","w":"auto"}
      ],
      tabData:[],
      edi_state:"",
      li_state:[
        {
          value:1,
          label:'离线'
        },
        {
          value:2,
          label:'在线'
        },
        {
          value:3,
          label:'故障'
        },
        {
          value:4,
          label:'其他'
        }
      ],
      edi_lock:0,
      li_lock:[
        {
          value:1,
          label:'锁定'
        },
        {
          value:0,
          label:'解锁'
        }
      ],
      post_head:{},
      daidelDev:false
    };
  },
  methods:{ /*方法存放*/
    change_lock(){
      if(this.is_lock) {
        this.is_lock = false;
      } else {
        this.is_lock = true;
      }
    },
    getLabelByValue(items,value){
      if(items) {
        const item = items.find(item => item.value === value);
        return item ? item.label : null; // 如果未找到，返回null或适当的默认值
      } else {
        return null;
      }
    },
    syn_dvc(row){
      console.log(row);
      this.did = row.did;
      this.pid = row.pid;
      this.synPidArg(row.pid);
    },
    ctrol_dvc(row){
      console.log(row);
      this.did = row.did;
      this.pid = row.pid;
      this.titles = row.devName;
      this.getPidArg(row.pid,row.did);
    },
    addDev(){
      this.$router.push({ /*路由跳转传值*/
        path:'/home/glDevListSon',
        query:{key:'addDev',li_pid:this.li_pid}
      });
    },
    change_dvc(row){
      console.log(row);
      this.$router.push({ /*路由跳转传值*/
        path:'/home/glDevListSon',
        query:{
          key:'changeDev',
          did:row.did,
          roomId:row.roomId,
          floorId:row.floorId,
          buildId:row.buildId,
          devName:row.devName,
          devMac:row.devMac,
          pid:row.pid,
          li_pid:this.li_pid
        }
      });
    },
    del_Dev(row){
      console.log(row);
      this.did = row.did;
      this.pid = row.pid;
      this.daidelDev = true;
    },
    delDev(){
      const params = {
        'did':this.did,
        'pid':this.pid,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daidelDev = false;
        this.getDev();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("删除失败");
        }
      });
    },
    on_pwr(name,value){
      let params = {
        "did":this.did,
        "pid":this.pid,
        "cmd":{},
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      params["cmd"][name] = value;
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.deviceCtrl,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("控制成功");
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("控制失败");
        }
      });
    },
    query_device(row){
      const params = {
        "did":row.did,
        "pid":row.pid,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.queryDevice,params,headers).then(res => {
        console.log(res.data.msg);
        this.$message.success(res.data.msg);
        row["statusId"] = res.data.data["ioTPidDevice"]["status"]["id"];
        row["statusName"] = res.data.data["ioTPidDevice"]["status"]["name"];
        let id1 = this.tabData.findIndex((index) => { /*js快速查找数组索引*/
          if(index['did'].toLowerCase() === row.did) {
            return true;
          }
        });
        if(id1 !== -1) {
          this.tabData[id1] = row;
          console.log(row);
        }
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("查询设备数据失败");
        }
      });
    },
    find_dvcState(row){ /*查询设备状态*/
      console.log(row);
      const params = {
        "did":row.did,
        "pid":row.pid,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.trigQueryDeviceState,params,headers).then(res => {
        console.log(res.data.msg);
        this.$message.success(res.data.msg);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("触发设备上报失败");
        }
      });
    },
    synPidArg(pid){ /*同步设备信息*/
      const params = {
        "did":this.did,
        "pid":pid,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.syncBleGatewayState,params,headers).then(res => {
        console.log(res.data);
        this.$message.success("同步设备信息成功");
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("同步设备信息失败");
        }
      });
    },
    getPidArg(pid,did){
      const params = {
        'pid':pid
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getPidArg,params,headers).then(res => {
        console.log("pid参数",res.data.data);
        let data = res.data.data["iotPidProfile"]["properities"];
        console.log("data",data);
        // if (this.li_ctl.length > 0 && "did" in this.li_ctl[0]) {
        //   for (let i = 0; i < this.li_ctl.length; i++) {
        //     if (this.li_ctl[i]["name"] in d) {
        //       this.li_ctl[i].value = d[this.li_ctl[i]["name"]]
        //     }
        //   }
        // }
        let index = this.li_data.findIndex((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          return fruit['did'] === did && fruit['pid'] === pid;
        });
        let l_d = {};
        if(index !== -1) {
          l_d = this.li_data[index];
        }
        let l = [];
        for(let i = 0; i < data.length; i++) {
          let d = {
            "pid":pid,
            "did":did,
            "name":data[i]['name'],
            "desc":data[i]['desc'],
            "type":data[i]["define"]['type'],
            "mode":data[i]['mode'],
            "value":""
          };
          if(d['type'] === 'int' || d['type'] === 'float') {
            d["step"] = parseInt(data[i]["define"]["step"]);
            d["min"] = parseInt(data[i]["define"]["min"]);
            d["max"] = parseInt(data[i]["define"]["max"]);
            if(data[i]['name'] in l_d) {
              d["value"] = parseInt(l_d[data[i]['name']]);
            } else {
              d["value"] = parseInt(data[i]["define"]["min"]);
            }
          } else if(d['type'] === 'enum') {
            let l1 = [];
            for(let j = 0; j < data[i]["define"]["mapping"].length; j++) {
              l1.push({
                "label":data[i]["define"]["mapping"][j]["desc"],
                "value":parseInt(data[i]["define"]["mapping"][j]["value"])
              });
            }
            d["li_d"] = l1;
            if(data[i]['name'] in l_d) {
              d["value"] = parseInt(l_d[data[i]['name']]);
            } else {
              d["value"] = parseInt(l1[0]["value"]);
            }
          } else { /*字符串*/
            // console.log(l_d)
            // console.log(data[i]['name'])
            if(data[i]['name'] in l_d) {
              d["value"] = l_d[data[i]['name']];
            }
          }
          l.push(d);
        }
        this.li_ctl = l;
        this.is_lock = false; /*将空调锁定相关按钮隐藏*/
        // "dmy_air_lan_zjl_100"
        if(pid.includes("zjl")) {
          this.daiCtrolKt = true;  /*显示空调弹窗*/
          console.log("空调值",this.li_ctl);
        } else if(pid.includes("dmy_air")) {
          this.daiCtrolKtSon = true;  /*显示空调弹窗*/
          console.log("空调值",this.li_ctl);
        } else {
          console.log("其他值",this.li_ctl);
          this.daiCtrol = true;  /*显示控制弹窗*/
        }
        console.log(l);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    tableYs({row,column,rowIndex,columnIndex}){ /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val){
      this.page = 1;
      this.pageSize = val;
      this.getDev();
    },
    handleCurrentChange1(val){
      this.page = val;
      this.getDev();
    },
    show_change1(item){
      if(item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item){
      if(item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item){
      if(item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    show_change4(item){
      if(item) {
        this.$refs.select4.focus();
      } else {
        this.$refs.select4.blur();
      }
    },show_change5(item){
      if(item) {
        this.$refs.select5.focus();
      } else {
        this.$refs.select5.blur();
      }
    },show_change6(item){
      if(item) {
        this.$refs.select6.focus();
      } else {
        this.$refs.select6.blur();
      }
    },
    timestampToTime(timestamp){
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Y + M + D + h + m + s;
    },
    init_View(){
      let l = [];
      // if (this.is_one) {
      //   this.state_all = 0
      // }
      // this.state_zx = 0
      // this.state_lx = 0
      // this.state_err = 0
      let data = this.li_dev;
      let li_d = [];
      let j = 1;
      let isVirtual = false;
      for(let i = 0; i < data.length; i++) {
        if(!data[i]["isShow"]) {
          continue;
        }
        // if (this.edi_pid && data[i].pid !== this.edi_pid) {
        //   continue
        // }
        // if (this.edi_state && data[i].statusId !== this.edi_state) {
        //   continue
        // }
        // if (this.scan_name && !data[i]['name'].includes(this.scan_name)) {
        //   continue
        // }
        // if (this.scan_mac && !data[i]['did'].toLowerCase().includes(this.scan_mac.toLowerCase())) {
        //   continue
        // }
        if(data[i]['isVirtual']) {
          isVirtual = true;
        }
        let d = {
          item:j,
          did:data[i]['did'],
          pid:data[i]['pid'],
          authName:data[i]['sysIotPid']['name'],
          devName:data[i]['name'],
          devMac:data[i]['did'],
          times:this.timestampToTime(data[i]['hearBeatTime'] * 1000),
          statusId:data[i]['statusId'],
          roomId:data[i]['roomId']
        };
        if(data[i]['roomId']) {
          d['floorId'] = data[i]['room']['floorId'];
          if(data[i]['room']['floor']) {
            d['buildId'] = data[i]['room']['floor']['buildingId'];
            d['devArea'] = data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            if(data[i]['room']['floor']['building']) {
              d['devArea'] = data[i]['room']['floor']['building']['name'] + "-" + data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            }
          }
        } else if(data[i]['floorId']) {
          d['floorId'] = data[i]['floorId'];
          if(data[i]['floor']) {
            d['buildId'] = data[i]['floor']['buildingId'];
            d['devArea'] = data[i]['floor']['name'];
            if(data[i]['floor']['building']) {
              d['devArea'] = data[i]['floor']['building']['name'] + "-" + data[i]['floor']['name'];
            }
          }
        }
        // if (this.is_one) {
        //   this.state_all += 1
        // }
        if(d["statusId"] === 0) { /* 为0时直接离线 */
          d["statusId"] = 1;
          d["statusName"] = "离线";
          // this.state_lx += 1
        } else {
          if(d["statusId"] === 1) {
            // this.state_lx += 1
            d["statusName"] = "离线";
          } else if(d["statusId"] === 2) {
            // this.state_zx += 1
            d["statusName"] = "在线";
          }
          if(d["statusId"] === 3) {
            // this.state_err += 1
            d["statusName"] = "故障";
          }
          // const state = this.li_state.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          //   return fruit['value'] === d.statusId;
          // })
          // if (state !== undefined) {
          //   d["statusName"] = state["label"];
          //   if (state["label"] === "在线") {
          //     this.state_zx += 1
          //   } else if (state["label"] === "离线") {
          //     this.state_lx += 1
          //   }
          //   if (state["label"] === "故障") {
          //     this.state_err += 1
          //   }
          // }
        }
        // const authItems = l.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        //   return fruit['value'] === d['pid']
        // })
        // if (authItems === undefined) {
        //   l.push({
        //     value: d['pid'],
        //     label: d['authName']
        //   })
        // }
        li_d.push(d);
        j += 1;
      }
      if(isVirtual) { /* 给父页面传递聚合设备存在信息 */
        this.$emit('updateData',{"isVirtual":true});
      }
      // console.log(this.state_zx, this.state_lx, this.state_err)
      // this.total = this.li_deviceList["total"]  /*当前页面总设备数量*/
      // this.tabData = li_d.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
      // this.li_pid = l
      this.tabData = li_d;
      this.is_one = false;
      if(this.websocket === null) {
        this.connect();
      } else {
        this.heartbeatMsg = {
          "type":"getDevState",
          "devices":[], // { "did": "ec0bf1069464","pid": "ble_light_rgbcw"}
          "projectId":localStorage.getItem("projectId")
        };
        for(let i = 0; i < this.li_dev.length; i++) {
          this.heartbeatMsg["devices"].push({"did":this.li_dev[i]["did"],"pid":this.li_dev[i]["pid"]});
        }
        if(this.websocket.readyState === WebSocket.OPEN) {
          console.log("socket发送数据",this.heartbeatMsg);
          this.websocket.send(JSON.stringify(this.heartbeatMsg));
        }
      }
    },
    getPid(){
      if(this.pidPage > this.pidTotal / 10 + 1) {
        return;
      }
      const params = {
        'page':this.pidPage,
        'pageSize':this.pidPageSize
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getPidList,params,headers).then(res => {
        console.log(res.data.data);
        this.pidTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_pid;
        for(let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['pid'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_pid = l;
        this.pidPage += 1;
        this.loading = false;
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取设备类型失败");
        }
      });
    },
    xhTime(){ /*循环定时*/
      clearInterval(this.timer_sjtime); /*清除定时器*/
      this.timer_sjtime = setInterval(() => {   //设置延迟执行
        this.getOnline(); /*获取顶部状态*/
        for(let i = 0; i < this.li_dev.length; i++) {
          const now = new Date();
          if(now.getTime() - this.li_dev[i]['times'] * 1000 <= 10 * 60 * 1000) {
            this.li_dev[i]["statusId"] = 2;
            this.li_dev[i]["statusName"] = "在线";
          } else {
            this.li_dev[i]["statusId"] = 1;
            this.li_dev[i]["statusName"] = "离线";
          }
        }
      },60000 * 5);
    },
    getOnline(){
      const params = {
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getOnlineInfo,params,headers).then(res => {
        console.log("设备状态",res.data.data);
        this.state_all = res.data.data["total"];
        this.state_zx = res.data.data["online"];
        this.state_lx = res.data.data["offline"];
        this.state_err = res.data.data["fault"];
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    init_getDev(){
      this.page = 1;
      this.getDev();
    },
    getDev(){
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if(this.edi_pid) {
        params["pid"] = this.edi_pid;
      }
      if(this.edi_state) {
        params["statusId"] = this.edi_state;
      }
      if(this.scan_name) {
        params["name"] = this.scan_name;
      }
      if(this.scan_mac) {
        params["did"] = this.scan_mac;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
        console.log("所有设备状态",res.data.data);
        this.total = res.data.data["total"];
        this.li_dev = res.data.data["list"];
        this.init_View();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    getDevState(){
      const params = {
        'page':1,
        'pageSize':1000
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getDeviceStatusList,params,headers).then(res => {
        let data = res.data.data.list;
        let l = [];
        for(let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['id'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_state = l;
        console.log("在线状态",this.li_state);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取设备类型失败");
        }
      });
    },
    on_lock(){ /*锁定*/
      const params = {
        "pid":this.pid,
        "did":this.did,
        "cmd":{
          "pwr":-1,      //0-关闭，1-开启，-1-不锁定
          "mode":-1,     //1-制热,2-制冷,4-送风,8-除湿,-1-不锁定
          "temp":-1,    //25-锁定恒温25度，22-锁定温度可调范围为20~26之间，其他-不锁定
          "speed":-1     //0-自动,1-低速,2-中速,3-高速,-1-不锁定
        },
        "projectId":localStorage.getItem("projectId")
      };
      if(this.edi_lock) {
        switch(this.xz_kg) {
          case "开机":
            params["cmd"]["pwr"] = 1;
            break;
          case "关机":
            params["cmd"]["pwr"] = 0;
            break;
          case "不锁":
            params["cmd"]["pwr"] = -1;
            break;
        }
        switch(this.xz_temp) {
          case "常温":
            params["cmd"]["temp"] = 22;
            break;
          case "25℃":
            params["cmd"]["temp"] = 25;
            break;
          case "不锁":
            params["cmd"]["temp"] = -1;
            break;
        }
        switch(this.xz_mode) {
          case "制热":
            params["cmd"]["mode"] = 1;
            break;
          case "制冷":
            params["cmd"]["mode"] = 2;
            break;
          case "送风":
            params["cmd"]["mode"] = 4;
            break;
          case "除湿":
            params["cmd"]["mode"] = 8;
            break;
          case "不锁":
            params["cmd"]["mode"] = -1;
            break;
        }
        switch(this.xz_fan) {
          case "自动":
            params["cmd"]["speed"] = 0;
            break;
          case "低风":
            params["cmd"]["speed"] = 1;
            break;
          case "中风":
            params["cmd"]["speed"] = 2;
            break;
          case "高风":
            params["cmd"]["speed"] = 3;
            break;
          case "不锁":
            params["cmd"]["speed"] = -1;
            break;
        }
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      console.log(localStorage.getItem("token"));
      console.log(this.$urls.ip + this.$urls.lockAllIndoors);
      this.$api.post(this.$urls.ip + this.$urls.lockAllIndoors,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("控制成功");
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("控制失败");
        }
      });
    },
    connect(){
      this.websocket = new WebSocket(this.$urls.websocketUrl + '/websocket/wsGetDevState',[localStorage.getItem("token")]);
      // this.websocket = new WebSocket('wss://localhost:12000/websocket/wsGetDevState', [localStorage.getItem("token")]);
      this.websocket.onopen = () => {
        console.log('连接成功');
        this.heartbeatMsg = {
          "type":"getDevState",
          "devices":[
            // { "did": "ec0bf1069464","pid": "ble_light_rgbcw"}
          ],
          "projectId":localStorage.getItem("projectId")
        };
        for(let i = 0; i < this.li_dev.length; i++) {
          this.heartbeatMsg["devices"].push({"did":this.li_dev[i]["did"],"pid":this.li_dev[i]["pid"]});
        }
        if(this.websocket.readyState === WebSocket.OPEN) {
          console.log("socket发送数据",this.heartbeatMsg);
          this.websocket.send(JSON.stringify(this.heartbeatMsg));
        }
      };
      this.websocket.onmessage = (event) => { /*打开后才接收数据*/
        if(this.websocket.readyState === WebSocket.OPEN) {
          let data = JSON.parse(event.data);
          this.handleReceivedData(data);
        }
      };
      this.timer_socket = setInterval(() => { /*心跳包*/
        if(this.websocket !== null && this.websocket.readyState === WebSocket.OPEN) {
          let heartbeatMsg1 = {
            "type":"heartbeat",
            "devices":[],
            "projectId":localStorage.getItem("projectId")
          };
          this.websocket.send(JSON.stringify(heartbeatMsg1));
        }
      },this.heartbeatInterval);
      this.websocket.onclose = () => { /*重连*/
        setTimeout(() => {
          if(this.websocket !== null) {
            console.log("重连websocket");
            this.connect();
          }
        },this.reconnectInterval);
      };
    },
    handleReceivedData(data){ /*消息处理*/
      console.log("----------");
      console.log(data);
      if(data && data.type !== "register") {
        if("length" in data) {
          console.log("length_1");
          for(let i = 0; i < data.length; i++) {
            let d = JSON.parse(data[i]["state"]);
            // if (this.li_ctl.length > 0 && "did" in this.li_ctl[0]) {
            //   for (let i = 0; i < this.li_ctl.length; i++) {
            //     if (this.li_ctl[i]["name"] in d && d["did"] === this.li_ctl[i]["did"]) {
            //       this.li_ctl[i].value = d[this.li_ctl[i]["name"]]
            //       console.log("up_ctl", this.li_ctl[i]["name"], d[this.li_ctl[i]["name"]])
            //     }
            //   }
            // }
            let index = this.li_data.findIndex((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
            });
            if(index === -1) {
              this.li_data.push(d);
            } else {
              this.li_data[index] = d;
            }
            let index1 = this.tabData.findIndex((fruit) => { /*总列表状态改变*/
              return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
            });
            if(index1 !== -1) {
              this.tabData[index1]["times"] = this.timestampToTime(data[i]['time'] * 1000);
              const now = new Date();
              if(now.getTime() - data[i]['time'] * 1000 <= 5 * 60 * 1000) {
                this.tabData[index1]["statusId"] = 2;
                this.tabData[index1]["statusName"] = "在线";
              } else {
                this.tabData[index1]["statusId"] = 1;
                this.tabData[index1]["statusName"] = "离线";
              }
              // this.tabData[index1]["times"] = moment().format('YYYY-MM-DD HH:mm:ss')
            }
            let index2 = this.li_dev.findIndex((fruit) => { /*弹窗状态改变*/
              return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
            });
            if(index2 !== -1) {
              // if (this.li_dev[index2]["statusId"] === 1) {
              //   this.state_zx += 1
              //   this.state_lx -= 1
              // }
              this.li_dev[index2]["hearBeatTime"] = data[i]['time'];
              const now = new Date();
              if(now.getTime() - data[i]['time'] * 1000 <= 5 * 60 * 1000) {
                this.li_dev[index2]["statusId"] = 2;
                this.li_dev[index2]["statusName"] = "在线";
              } else {
                this.li_dev[index2]["statusId"] = 1;
                this.li_dev[index2]["statusName"] = "离线";
              }
              // this.tabData[index2]["times"] = moment().format('YYYY-MM-DD HH:mm:ss')
            }
          }
        } else {
          console.log("length_2");
          if(!("state" in data)) {
            return;
          }
          let d = JSON.parse(data["state"]);
          console.log(d);
          // if (this.li_ctl.length > 0 && "did" in this.li_ctl[0]) {
          //   for (let i = 0; i < this.li_ctl.length; i++) {
          //     if (this.li_ctl[i]["name"] in d && d["did"] === this.li_ctl[i]["did"]) {
          //       this.li_ctl[i].value = d[this.li_ctl[i]["name"]]
          //       console.log("up_ctl", this.li_ctl[i]["name"], d[this.li_ctl[i]["name"]])
          //     }
          //   }
          // }
          let index = this.li_data.findIndex((fruit) => { /*js快速查找数组--筛选当前tree列表*/
            return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
          });
          if(index === -1) {
            this.li_data.push(d);
          } else {
            this.li_data[index] = d;
          }
          let index1 = this.tabData.findIndex((fruit) => { /*总列表状态改变*/
            return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
          });
          if(index1 !== -1) {
            this.tabData[index1]["times"] = this.timestampToTime(data['time'] * 1000);
            const now = new Date();
            if(now.getTime() - data['time'] * 1000 <= 5 * 60 * 1000) {
              this.tabData[index1]["statusId"] = 2;
              this.tabData[index1]["statusName"] = "在线";
            } else {
              this.tabData[index1]["statusId"] = 1;
              this.tabData[index1]["statusName"] = "离线";
            }
          }
          let index2 = this.li_dev.findIndex((fruit) => { /*弹窗状态改变*/
            return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
          });
          if(index2 !== -1) {
            // if (this.li_dev[index2]["statusId"] === 1) {
            //   this.state_zx += 1
            //   this.state_lx -= 1
            // }
            this.li_dev[index2]["hearBeatTime"] = data['time'];
            const now = new Date();
            if(now.getTime() - data['time'] * 1000 <= 5 * 60 * 1000) {
              this.li_dev[index2]["statusId"] = 2;
              this.li_dev[index2]["statusName"] = "在线";
            } else {
              this.li_dev[index2]["statusId"] = 1;
              this.li_dev[index2]["statusName"] = "离线";
            }
          }
        }
      }
      // console.log(this.li_ctl)
      // console.log(this.li_data)
      // console.log(this.li_dev)
    },
    scolling(){ /*下拉更新*/
      let e = this.$refs.select1.$refs.scrollbar.$refs.wrap;
      if(this.loading) return; /*loading为真跳过-防止误触*/
      let loadMore = e.scrollHeight - e.scrollTop - 1 <= e.clientHeight;
      if(loadMore) { /*到底时触发 loadMore*/
        this.loadMore();
      }
    },
    loadMore(){
      this.loading = true; // 设置加载状态为 true，防止重复请求
      this.getPid();
    }
  },
  mounted(){ /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    if(this.$urls.ip) {
      this.$refs.select1.$refs.scrollbar.$refs.wrap.addEventListener('scroll',this.scolling); /*绑定下拉组件方法*/
      // this.getDevState()
      this.getOnline();
      this.getDev();
      this.xhTime();
    } else {
      setTimeout(() => {
        this.$urls.ip = localStorage.getItem("srv_ip");
        this.$refs.select1.$refs.scrollbar.$refs.wrap.addEventListener('scroll',this.scolling); /*绑定下拉组件方法*/
        // this.getDevState()
        this.getOnline();
        this.getDev();
        this.xhTime();
      },200);
    }
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    // fil_tabData() {
    // return this.tabData.filter(item => {
    //   this.state = true
    //   if (this.edi_pid && item.pid !== this.edi_pid) {
    //     this.state = false
    //   }
    //   if (this.edi_state && item.statusId !== this.edi_state) {
    //     this.state = false
    //   }
    //   if (this.scan_name && !item.devName.includes(this.scan_name)) {
    //     this.state = false
    //   }
    //   if (this.scan_mac && !item.devMac.includes(this.scan_mac)) {
    //     this.state = false
    //   }
    //   return this.state
    // });
    // },
    fil_li_ctl(){
      return this.li_ctl;
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy(){ /*页面结束时调用*/
    clearInterval(this.timer_sjtime); /*清除定时器*/
    this.timer_sjtime = null;
    clearInterval(this.timer_socket); /*清除定时器*/
    this.timer_socket = null;
    if(this.websocket !== null) { /*关闭websocket*/
      console.log("关闭websocket");
      if(this.websocket.readyState === WebSocket.OPEN) {
        let heartbeatMsg1 = {
          "type":"unregister",
          "devices":[],
          "projectId":localStorage.getItem("projectId")
        };
        this.websocket.send(JSON.stringify(heartbeatMsg1));
      }
      this.websocket.close();
      this.websocket = null;
    }
  }
};
</script>

<style>
#aDev {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main1 {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 60px;
  border-radius: 5px 5px 5px 5px;
}

.dialog_daiAddDev1 {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    background: #FFFFFF;
  }

  .el-dialog__body {
    color: #000000;
    background: #ECF0F2;
  }
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(90% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

.fg_x {
  background: #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/gls/glDevList.vue